import React from "react";
import { observer } from "mobx-react";
import SparkleIcon from "Components/common/SparkleIcon";
import userDetail from "Stores/userDetail";
import copilotStore from "Stores/copilotStore";
import copilotDrawerStore from "Stores/copilotDrawerStore";
import { navCounts } from "Global/SideBar/navCounts";
import { signalsData } from "Stores/signalsData";
import { agentsData, needsYouCount } from "Stores/agentsData";
import { outboxStoreData } from "Pages/Dashboard/outbox/outboxStore";
import { buildSuggestions } from "./drawerSuggestions";
import "./drawerHome.scss";

/*
 * The panel's empty state, after the Breeze study: a greeting, three suggestions built from the
 * user's own numbers, four verb tiles. Every count here is already loaded for the left nav
 * (tasks, inbox, signals, agents) or the page reader, so opening the panel adds no request.
 */

const TILES = [
  { key: "summarize", icon: "description", label: "Summarize", prompt: "Summarize this page" },
  { key: "find", icon: "search", label: "Find", prompt: "Find people who match my ICP" },
  { key: "draft", icon: "edit", label: "Draft", prompt: "Draft a follow-up email" },
  // "How do I" starts the sentence; the user finishes it.
  { key: "howto", icon: "help_outline", label: "How do I", draft: "How do I " }
];

const DrawerHome = observer(() => {
  const firstName = userDetail?.userInfo?.firstName || "";
  const pageFinding = (copilotDrawerStore.pageFindings || [])[0]?.text || "";
  const suggestions = buildSuggestions({
    pageFinding,
    tasksLate: navCounts.tasksLate,
    tasksToday: navCounts.tasksToday,
    inboxUnread: outboxStoreData?.unreadOutboxCount,
    signalsNew: signalsData?.unreadCount,
    agentsNeedYou: needsYouCount(agentsData?.overview?.agents)
  });

  return (
    <div className="cdHome">
      <div className="cdHome__greeting">
        <SparkleIcon className="cdHome__spark" />
        <h1 className="cdHome__title">
          Ready when you are{firstName ? `, ${firstName}` : ""}
        </h1>
      </div>

      <div className="cdHome__suggested">
        <div className="cdHome__suggestedHead">
          <i className="material-icons-outlined">lightbulb</i>
          Suggested
        </div>
        {suggestions.map(s => (
          <button
            type="button"
            key={s.key}
            className="cdHome__suggestion"
            onClick={() => copilotStore.sendUserMessage(s.prompt)}
          >
            <i className="material-icons-outlined">subdirectory_arrow_right</i>
            <span>{s.text}</span>
          </button>
        ))}
      </div>

      <div className="cdHome__tiles">
        {TILES.map(t => (
          <button
            type="button"
            key={t.key}
            className="cdHome__tile"
            onClick={() => {
              if (t.draft) copilotStore.composerDraft = t.draft;
              else copilotStore.sendUserMessage(t.prompt);
            }}
          >
            <i className="material-icons-outlined">{t.icon}</i>
            <span>{t.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
});

export default DrawerHome;
